import _classCallCheck from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as r from "restructure";
import { concatenateUint8Arrays, readUInt8 } from "./utils.js";
var HuffmanTableElements = /*#__PURE__*/function () {
  function HuffmanTableElements() {
    _classCallCheck(this, HuffmanTableElements);
  }
  _createClass(HuffmanTableElements, [{
    key: "decode",
    value: function decode(stream, parent) {
      var tables = {};
      var buffer = stream.buffer.slice(stream.pos, stream.pos + parent.length - 2);
      while (buffer.length > 0) {
        var offset = 1;
        var elements = [];
        var identifier = readUInt8(buffer, 0);
        var lengths = buffer.slice(offset, offset + 16);
        offset += 16;
        var _iterator = _createForOfIteratorHelper(lengths),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var length = _step.value;
            elements.push(buffer.slice(offset, offset + length));
            offset += length;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        buffer = buffer.slice(offset);
        tables[identifier] = concatenateUint8Arrays(elements);
      }
      stream.pos += parent.length - 2;
      return tables;
    }
  }]);
  return HuffmanTableElements;
}();
var DefineHuffmanTableMarker = {
  name: function name() {
    return "DHT";
  },
  length: r.uint16be,
  tables: new HuffmanTableElements()
};
export default DefineHuffmanTableMarker;